import React from 'react';
import ProductPage from '../components/ProductPage';

const ApplianceCover = () => (
  <ProductPage
    eyebrow="Appliance Service Plans"
    title={<>Maintenance service plans for the <span className="text-[#FF5C39]">appliances</span> you rely on</>}
    tagline="Simple monthly or annual service plans for washing machines, fridge-freezers, ovens and more. Repair and maintenance visits are arranged through our network of qualified engineers. This is a maintenance service agreement — not an insurance product."
    heroImage="https://images.unsplash.com/photo-1709477542151-b98344ef6253?w=1400&q=80"
    monthlyPrice="8.99"
    annualPrice="99.99"
    badge={{ top: 'Choose your plan', value: 'Monthly or annual' }}
    includes={[
      'Mechanical & electrical breakdown support',
      'Parts and labour arranged under the plan',
      'Repairs by qualified UK service providers',
      'Replacement subject to plan Terms & Conditions',
      'Monthly or annual payment options',
      'Multi-appliance plans for up to 5 appliances',
      '"All Inclusive" plan for up to 7 appliances',
      'Cancel any time — 14-day cooling off period',
    ]}
    notCovered={[
      'Pre-existing faults from before your plan started',
      'Wear-and-tear items (belts, filters, hoses)',
      'Cosmetic damage that does not affect function',
      'Appliances used commercially',
    ]}
  />
);

export default ApplianceCover;
